import React, { useEffect, useRef, useState } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { DrainFieldInstallationInspectionInput, schema, DrainFieldInstallationInspectionFormProps, ComplianceData } from "./DrainFieldInstallationInspectionForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
import useInspectionClient from "../../hooks/useInspectionClient";
import { SelectOption } from "../../types";
// import { usePrettyPrintedState } from './usePrettyPrintedState'


export const DrainfieldInstallationInspectionForm = (props: DrainFieldInstallationInspectionFormProps) => {
    const history = useHistory();
    const path = usePath();
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const drainfieldProductMakeData = useData<SelectOption[]>("DrainfieldProductMake") || [];
    const [drainfieldProductModelData, setDrainfieldProductModelData] = useState<SelectOption[]>([{ id: 0, name: "Please select a value" }]);
    const [drainfieldProductModelData2, setDrainfieldProductModelData2] = useState<SelectOption[]>([{ id: 0, name: "Please select a value" }]);
    const previousProductMakeIdRef = useRef<number | string | undefined>(undefined);
    const previousProductMakeId2Ref = useRef<number | string | undefined>(undefined);
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
    const inspectionClient = useInspectionClient();
   
      const user =  useProfile(application) as UserSecurityInput;
    const { control, handleSubmit, setValue, watch } = useForm<DrainFieldInstallationInspectionInput>({
        defaultValues: {
            ...props.values,
            isDrainfield2Showable: props.values?.isDrainfield2Showable ?? !!props.values?.areaComplianceId2,
        },
        resolver: yupResolver(schema),
       
    });
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);
    const formRef = useRef<HTMLFormElement>(null);

    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }

    const businessUnits = [{
        id: 0,
        name: "Select D-box or header"
    },
    {
        id: 1,
        name: "D-Box"
    },
    {
            id: 2,
            name: "Header"
    }];
    const businessUnits1 = [
        {
            id: 0,
            name: "Select above or below"
        },
        {
        id: 1,
        name: "Above"
    },
    {
        id: 2,
        name: "Below"
        }];

        const businessUnits2 = [
            {
                id: 0,
                name: "Select bed or trench"
            },
            {
            id: 1,
            name: "Bed"
        },
        {
            id: 2,
            name: "Trench"
            }];

    const onSubmit = useSubmitForm<DrainFieldInstallationInspectionInput>(
        'drainfieldInstallation',
        async (response) => {
            toast.success("Drainfield Installation Saved Successfully");
            await timeout(2000);
            let inspectionStatus = watch("inspectionStatusId");
            if(inspectionStatus == InspectionStatus.Complete){
                if(inspectionStatusData?.fillExcavationMaterialInspectionId == null 
                    || inspectionStatusData?.fillExcavationMaterialInspectionId == undefined){
                        history.push({
                            pathname: "/fillExcavationMaterial/",
                            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        })
                    }
                    else {
                        history.push({
                            pathname: "/fillExcavationMaterial/"+ inspectionStatusData?.fillExcavationMaterialId,
                            search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                        })
                    }
            }
            else if (inspectionStatus == InspectionStatus.Incomplete){
                history.push(`/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`) ;
            }
        },
        props.action
    );

    const submit = () => {
        const showDrainfield2 = watch("isDrainfield2Showable");
        setValue('applicationId', props.applicationId ? props.applicationId : 0);
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
        if (!showDrainfield2) {
            setValue("productComplianceId2", null as any);
            setValue("productComment2", null as any);
            setValue("productMakeId2", null as any);
            setValue("productModelId2", null as any);
            setValue("areaComplianceId2", null as any);
            setValue("areaComment2", null as any);
            setValue("area2", null as any);
            setValue("distributionComplianceId2", null as any);
            setValue("distributionComment2", null as any);
            setValue("distributionBoxOrHeader2", null as any);
            setValue("numberOfDrainlinesComplianceId2", null as any);
            setValue("numberOfDrainlinesComment2", null as any);
            setValue("numberOfDrainline12", null as any);
            setValue("numberOfUnits2", null as any);
            setValue("drainlineSeparationComplianceId2", null as any);
            setValue("drainlineSeparationComment2", null as any);
            setValue("drainlineSeparationBedOrTrench2", null as any);
            setValue("drainlineSlopeComplianceId2", null as any);
            setValue("drainlineSlopeComment2", null as any);
            setValue("depthOfCoverComplianceId2", null as any);
            setValue("depthOfCoverComment2", null as any);
            setValue("elevationComplianceId2", null as any);
            setValue("elevationComment2", null as any);
            setValue("elevation12", null as any);
            setValue("elevationBenchmark2", null as any);
            setValue("systemLocationComplianceId2", null as any);
            setValue("systemLocationComment2", null as any);
            setValue("dosingPumpComplianceId2", null as any);
            setValue("dosingPumpComment2", null as any);
            setValue("dosingPump2", null as any);
            setValue("aggregateSizeComplianceId2", null as any);
            setValue("aggregateSizeComment2", null as any);
            setValue("aggregateExcessiveComplianceId2", null as any);
            setValue("aggregateExcessiveComment2", null as any);
            setValue("aggregateDepthComplianceId2", null as any);
            setValue("aggregateDepthComment2", null as any);
        }
        if(inspectionStatusData?.drainfieldInstallationInspectionId == null 
            || inspectionStatusData?.drainfieldInstallationInspectionId == undefined){
                setValue('dateCreated', new Date());
                setValue('createdBy', user?.userName);
            }
            else {
                setValue('dateUpdated', new Date());
                setValue('updatedBy', user?.userName);
            }
        if (formRef.current) {

            formRef.current.dispatchEvent(
                new Event('submit', { cancelable: true, bubbles: true })
            );

        }
    }


    let showAreaComment = watch("areaComplianceId");
    let showProductComment = watch("productComplianceId1");
    let selectedProductMakeId = watch("productMakeId1");
    let showDrainfield2 = watch("isDrainfield2Showable");
    let showProductComment2 = watch("productComplianceId2");
    let selectedProductMakeId2 = watch("productMakeId2");
    let showAreaComment2 = watch("areaComplianceId2");
    let showDitributionComment2 = watch("distributionComplianceId2");
    let showNumberOfDrainlinesComment2 = watch("numberOfDrainlinesComplianceId2");
    let showDrainlineSeparationComment2 = watch("drainlineSeparationComplianceId2");
    let showDrainlineSlopeComment2 = watch("drainlineSlopeComplianceId2");
    let showDepthOfCoverComment2 = watch("depthOfCoverComplianceId2");
    let showElevationComment2 = watch("elevationComplianceId2");
    let showSystemLocationComment2 = watch("systemLocationComplianceId2");
    let showDosingPumpComment2 = watch("dosingPumpComplianceId2");
    let showAggregateSizeComment2 = watch("aggregateSizeComplianceId2");
    let showAggregateExcessiveComment2 = watch("aggregateExcessiveComplianceId2");
    let showAggregateDepthComment2 = watch("aggregateDepthComplianceId2");
    let showDitributionComment = watch("distributionComplianceId");
    let showNumberOfDrainlinesComment = watch("numberOfDrainlinesComplianceId");
    let showDrainlineSeparationComment = watch("drainlineSeparationComplianceId");
    let showDrainlineSlopeComment = watch("drainlineSlopeComplianceId");
    let showDepthOfCoverComment = watch("depthOfCoverComplianceId");
    let showElevationComment = watch("elevationComplianceId");
    let showSystemLocationComment = watch("systemLocationComplianceId");
    let showDosingPumpComment = watch("dosingPumpComplianceId");
    let showAggregateSizeComment = watch("aggregateSizeComplianceId");
    let showAggregateExcessiveComment = watch("aggregateExcessiveComplianceId");
    let showAggregateDepthComment = watch("aggregateDepthComplianceId");
    let markAllCompliance = watch("markAll");

    useEffect(() => {
        const loadModels = async () => {
            try {
                if (selectedProductMakeId && Number(selectedProductMakeId) > 0) {
                    const response = await inspectionClient.api(`DrainfieldProductModel/by-make/${selectedProductMakeId}`).get();
                    setDrainfieldProductModelData(response.data || [{ id: 0, name: "Please select a value" }]);
                }
                else {
                    setDrainfieldProductModelData([{ id: 0, name: "Please select a value" }]);
                }

                if (previousProductMakeIdRef.current !== undefined && previousProductMakeIdRef.current !== selectedProductMakeId) {
                    setValue("productModelId1", 0);
                }

                previousProductMakeIdRef.current = selectedProductMakeId;
            }
            catch {
                setDrainfieldProductModelData([{ id: 0, name: "Please select a value" }]);
                if (previousProductMakeIdRef.current !== undefined && previousProductMakeIdRef.current !== selectedProductMakeId) {
                    setValue("productModelId1", 0);
                }
                previousProductMakeIdRef.current = selectedProductMakeId;
            }
        };

        loadModels();
    }, [selectedProductMakeId, setValue]);

    useEffect(() => {
        const loadModels2 = async () => {
            try {
                if (selectedProductMakeId2 && Number(selectedProductMakeId2) > 0) {
                    const response = await inspectionClient.api(`DrainfieldProductModel/by-make/${selectedProductMakeId2}`).get();
                    setDrainfieldProductModelData2(response.data || [{ id: 0, name: "Please select a value" }]);
                }
                else {
                    setDrainfieldProductModelData2([{ id: 0, name: "Please select a value" }]);
                }

                if (previousProductMakeId2Ref.current !== undefined && previousProductMakeId2Ref.current !== selectedProductMakeId2) {
                    setValue("productModelId2", 0);
                }

                previousProductMakeId2Ref.current = selectedProductMakeId2;
            }
            catch {
                setDrainfieldProductModelData2([{ id: 0, name: "Please select a value" }]);
                if (previousProductMakeId2Ref.current !== undefined && previousProductMakeId2Ref.current !== selectedProductMakeId2) {
                    setValue("productModelId2", 0);
                }
                previousProductMakeId2Ref.current = selectedProductMakeId2;
            }
        };

        if (showDrainfield2) {
            loadModels2();
        }
    }, [selectedProductMakeId2, setValue, showDrainfield2]);

    const h1Styles: CSS.Properties = {
        float: "right",
        marginTop: '27px'
    };
    const markClick = (e: any) => {
        //showSerfaceWaterComment = markAllCompliance;
        setValue('productComplianceId1', markAllCompliance);
        setValue('areaComplianceId', markAllCompliance);
        setValue('distributionComplianceId', markAllCompliance);
        setValue('numberOfDrainlinesComplianceId', markAllCompliance);
        setValue('drainlineSeparationComplianceId', markAllCompliance);
        setValue('drainlineSlopeComplianceId', markAllCompliance);
        setValue('depthOfCoverComplianceId', markAllCompliance);
        setValue('elevationComplianceId', markAllCompliance);
        setValue('systemLocationComplianceId', markAllCompliance);
        setValue('dosingPumpComplianceId', markAllCompliance);
        setValue('aggregateSizeComplianceId', markAllCompliance);
        setValue('aggregateDepthComplianceId', markAllCompliance);
        setValue('aggregateExcessiveComplianceId', markAllCompliance);
        if (showDrainfield2) {
            setValue('productComplianceId2', markAllCompliance);
            setValue('areaComplianceId2', markAllCompliance);
            setValue('distributionComplianceId2', markAllCompliance);
            setValue('numberOfDrainlinesComplianceId2', markAllCompliance);
            setValue('drainlineSeparationComplianceId2', markAllCompliance);
            setValue('drainlineSlopeComplianceId2', markAllCompliance);
            setValue('depthOfCoverComplianceId2', markAllCompliance);
            setValue('elevationComplianceId2', markAllCompliance);
            setValue('systemLocationComplianceId2', markAllCompliance);
            setValue('dosingPumpComplianceId2', markAllCompliance);
            setValue('aggregateSizeComplianceId2', markAllCompliance);
            setValue('aggregateDepthComplianceId2', markAllCompliance);
            setValue('aggregateExcessiveComplianceId2', markAllCompliance);
        }
       

        e.preventDefault();
    };

    return (
        <form id={props.id} ref={formRef} onSubmit={handleSubmit((data: DrainFieldInstallationInspectionInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Drainfield Installation
                    </div>
                </div>
                <div className="col col-md-3 ms-auto">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        required
                    />
                </div>
                <div className="col col-md-1" style={h1Styles}>
                    <Button className="btn btn-primary" onClick={markClick} >Apply</Button>
                </div>
            </div>

            <Card.Container>

                <Card.Header>
                    <Card.Title>{props.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="productComplianceId1"
                                    label="Alt. Drainfield Product"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="productMakeId1"
                                    label="Drainfield Product Make"
                                    options={drainfieldProductMakeData}
                                    required={showProductComment != Constants.Not_Applicable && showProductComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="productModelId1"
                                    label="Drainfield Product Model"
                                    options={drainfieldProductModelData}
                                    required={showProductComment != Constants.Not_Applicable && showProductComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showProductComment &&
                            showProductComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="productComment1"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="areaComplianceId"
                                    label="Drainfield Area"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="area1"
                                    label="Area (Sq.ft)"
                                    required= {showAreaComment != Constants.Not_Applicable && showAreaComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showAreaComment &&
                            showAreaComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="areaComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="distributionComplianceId"
                                    label="Distribution Box"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="distributionBoxOrHeader"
                                    label="Is it a box or header?"
                                    options={businessUnits}
                                    required= {showDitributionComment != Constants.Not_Applicable && showDitributionComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showDitributionComment &&
                            showDitributionComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="distributionComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="numberOfDrainlinesComplianceId"
                                    label="Number of Drainlines"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="numberOfDrainline1"
                                    label="Number of Drainlines"
                                    required= {showNumberOfDrainlinesComment != Constants.Not_Applicable && showNumberOfDrainlinesComment !=Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="numberOfUnits1"
                                    label="Number of Units"
                                    //type="number"
                                    // colSize={[{ size: "md", columns: "11" }]}
                                    required= {showNumberOfDrainlinesComment != Constants.Not_Applicable && showNumberOfDrainlinesComment !=Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showNumberOfDrainlinesComment &&
                            showNumberOfDrainlinesComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="numberOfDrainlinesComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainlineSeparationComplianceId"
                                    label="Drainline Separation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainlineSeparationBedOrTrench"
                                    label="Is it a Bed or Trench?"
                                    options={businessUnits2}
                                    required= {showDrainlineSeparationComment != Constants.Not_Applicable && showDrainlineSeparationComment !=Constants.Unobserved }
                                />
                            </div>
                      
                        </div>
                        {showDrainlineSeparationComment &&
                            showDrainlineSeparationComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="drainlineSeparationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="drainlineSlopeComplianceId"
                                    label="Drainline Slope"
                                    options={complianceData}
                                    required
                                />
                            </div>
                   
                        </div>
                        {showDrainlineSlopeComment &&
                            showDrainlineSlopeComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="drainlineSlopeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="depthOfCoverComplianceId"
                                    label="Depth of Absorption Surface"
                                    options={complianceData}
                                    required
                                />
                            </div>
                          
                        </div>
                        {showDepthOfCoverComment &&
                            showDepthOfCoverComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="depthOfCoverComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="elevationComplianceId"
                                    label="Elevation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="elevation1"
                                    label="Elevation (inches)"
                                    required= {showElevationComment != Constants.Not_Applicable && showElevationComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="elevationBenchmark"
                                    label="Above or below benchmark?"
                                    options={businessUnits1}
                                    required= {showElevationComment != Constants.Not_Applicable && showElevationComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showElevationComment &&
                            showElevationComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="elevationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="systemLocationComplianceId"
                                    label="Drainfield Location"
                                    options={complianceData}
                                    required
                                />
                            </div>
                          
                        </div>
                        {showSystemLocationComment &&
                            showSystemLocationComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="systemLocationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="dosingPumpComplianceId"
                                    label="Dosing Pumps"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="dosingPump"
                                    label="Number of Dosing Pumps"
                                    required= {showDosingPumpComment != Constants.Not_Applicable && showDosingPumpComment !=Constants.Unobserved }
                                />
                            </div>
                          
                        </div>
                        {showDosingPumpComment &&
                            showDosingPumpComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="dosingPumpComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="aggregateSizeComplianceId"
                                    label="Mineral Aggregate Size"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showAggregateSizeComment &&
                            showAggregateSizeComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="aggregateSizeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="aggregateExcessiveComplianceId"
                                    label="Mineral Aggregate Excessive Fines"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showAggregateExcessiveComment &&
                            showAggregateExcessiveComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="aggregateExcessiveComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="aggregateDepthComplianceId"
                                    label="Mineral Aggregate Depth"
                                    options={complianceData}
                                    required
                                />
                            </div>

                        </div>
                        {showAggregateDepthComment &&
                            showAggregateDepthComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="aggregateDepthComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Created By"
                                    required
                                />
                                <FormControl.Hidden
                                    control={control}
                                    name="applicationInspectionId"
                                    required
                                />
                                <FormControl.Hidden
                                    control={control}
                                    name="isDrainfield2Showable"
                                />
                            </div>


                        </div>

                    </></Layout.Row>
                </Card.Body>

                <div hidden={showDrainfield2}>
                    <Button id="showme" className="btn btn-primary ms-auto" onClick={(e) => {
                        e.preventDefault();
                        setValue("isDrainfield2Showable", true);
                    }}>
                        Add Drainfield
                    </Button>
                </div>

                {showDrainfield2 && (
                    <Card.Body>
                        <div className="row mb-4">
                            <div className="col col-md-8">
                                <div className="d-flex align-items-center">
                                    <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 40, height: 40 }}>
                                        <span className="fw-bold">2</span>
                                    </div>
                                    <div>
                                        <h3 className="text-primary mb-1 fw-bold">Drainfield 2</h3>
                                        <p className="text-muted mb-0">Additional drainfield installation details</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-md-4 text-end">
                                <button className="btn btn-danger" onClick={(e) => {
                                    e.preventDefault();
                                    setValue("isDrainfield2Showable", false);
                                }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-trash me-1" width="18" height="18" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M4 7l16 0"></path>
                                        <path d="M10 11l0 6"></path>
                                        <path d="M14 11l0 6"></path>
                                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                    </svg>
                                    Remove Drainfield
                                </button>
                            </div>
                        </div>

                        <div className="row border-top border-2 border-primary pt-4">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="productComplianceId2" label="Alt. Drainfield Product" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="productMakeId2" label="Drainfield Product Make" options={drainfieldProductMakeData} required={showProductComment2 != Constants.Not_Applicable && showProductComment2 != Constants.Unobserved} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="productModelId2" label="Drainfield Product Model" options={drainfieldProductModelData2} required={showProductComment2 != Constants.Not_Applicable && showProductComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showProductComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="productComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="areaComplianceId2" label="Drainfield Area" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text control={control} name="area2" label="Area (Sq.ft)" required={showAreaComment2 != Constants.Not_Applicable && showAreaComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showAreaComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="areaComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="distributionComplianceId2" label="Distribution Box" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="distributionBoxOrHeader2" label="Is it a box or header?" options={businessUnits} required={showDitributionComment2 != Constants.Not_Applicable && showDitributionComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showDitributionComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="distributionComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="numberOfDrainlinesComplianceId2" label="Number of Drainlines" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text control={control} name="numberOfDrainline12" label="Number of Drainlines" required={showNumberOfDrainlinesComment2 != Constants.Not_Applicable && showNumberOfDrainlinesComment2 != Constants.Unobserved} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text control={control} name="numberOfUnits2" label="Number of Units" required={showNumberOfDrainlinesComment2 != Constants.Not_Applicable && showNumberOfDrainlinesComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showNumberOfDrainlinesComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="numberOfDrainlinesComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="drainlineSeparationComplianceId2" label="Drainline Separation" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="drainlineSeparationBedOrTrench2" label="Is it a Bed or Trench?" options={businessUnits2} required={showDrainlineSeparationComment2 != Constants.Not_Applicable && showDrainlineSeparationComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showDrainlineSeparationComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="drainlineSeparationComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="drainlineSlopeComplianceId2" label="Drainline Slope" options={complianceData} required={showDrainfield2} />
                            </div>
                        </div>
                        {showDrainlineSlopeComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="drainlineSlopeComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="depthOfCoverComplianceId2" label="Depth of Absorption Surface" options={complianceData} required={showDrainfield2} />
                            </div>
                        </div>
                        {showDepthOfCoverComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="depthOfCoverComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="elevationComplianceId2" label="Elevation" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text control={control} name="elevation12" label="Elevation (inches)" required={showElevationComment2 != Constants.Not_Applicable && showElevationComment2 != Constants.Unobserved} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="elevationBenchmark2" label="Above or below benchmark?" options={businessUnits1} required={showElevationComment2 != Constants.Not_Applicable && showElevationComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showElevationComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="elevationComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="systemLocationComplianceId2" label="Drainfield Location" options={complianceData} required={showDrainfield2} />
                            </div>
                        </div>
                        {showSystemLocationComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="systemLocationComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="dosingPumpComplianceId2" label="Dosing Pumps" options={complianceData} required={showDrainfield2} />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text control={control} name="dosingPump2" label="Number of Dosing Pumps" required={showDosingPumpComment2 != Constants.Not_Applicable && showDosingPumpComment2 != Constants.Unobserved} />
                            </div>
                        </div>
                        {showDosingPumpComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="dosingPumpComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="aggregateSizeComplianceId2" label="Mineral Aggregate Size" options={complianceData} required={showDrainfield2} />
                            </div>
                        </div>
                        {showAggregateSizeComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="aggregateSizeComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="aggregateExcessiveComplianceId2" label="Mineral Aggregate Excessive Fines" options={complianceData} required={showDrainfield2} />
                            </div>
                        </div>
                        {showAggregateExcessiveComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="aggregateExcessiveComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select control={control} name="aggregateDepthComplianceId2" label="Mineral Aggregate Depth" options={complianceData} required={showDrainfield2} />
                            </div>
                        </div>
                        {showAggregateDepthComment2 == Constants.Out_of_Compliance && (
                            <div className="row">
                                <div className="col col-md-12">
                                    <FormControl.TextArea control={control} name="aggregateDepthComment2" label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)" required />
                                </div>
                            </div>
                        )}
                    </Card.Body>
                )}
                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()
                        }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span>                        
                        <div className="btn-list ms-auto">
                            <Link
                                to={props.returnPath ?? path.current}
                                className="btn btn-light"
                                role="button">
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()
                            }}>Next</Button>
                        </div>                        
                    </div>
                </Card.Footer>
            </Card.Container>
        </form>
    );
};

export default DrainfieldInstallationInspectionForm;




